<template>
  <svg
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00731 1.09949C1.76568 0.900172 1.37718 0.900172 1.13555 1.09949C1.01341 1.20024 0.95 1.33461 0.95 1.47135C0.95 1.6081 1.01341 1.74247 1.13555 1.84322L4.56412 4.67135C4.80575 4.87066 5.19425 4.87066 5.43588 4.67135L8.86445 1.84322C8.98659 1.74247 9.05 1.6081 9.05 1.47135C9.05 1.33461 8.98659 1.20024 8.86445 1.09949C8.62282 0.900172 8.23432 0.900172 7.99269 1.09949L5 3.56807L2.00731 1.09949Z"
      fill="#AFAFBE"
      stroke="#AFAFBE"
      stroke-width="0.1"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="stroke"
    />
  </svg>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/variables" as *;

.input-select-active svg .stroke {
  stroke: $primary;
  fill: $primary;
}
.item-combobox.error--text svg .stroke {
  stroke: #ff6c69;
  fill: #ff6c69;
}
</style>
